import { Injectable, Injector, ComponentFactoryResolver } from '@angular/core';
import { PerformerEditComponent } from './views/performer-edit/performer-edit.component';
import { BsModalService } from '@farris/ui-modal';

@Injectable()
export class PerformerViewModel {
    constructor(
        private resolver: ComponentFactoryResolver,
        private injector: Injector,
        private modalService: BsModalService
    ) { }
}
